import React, { useCallback, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { ModalGallery } from 'stream-chat-react'
import type { ModalGalleryProps } from 'stream-chat-react'
import { Box } from '@material-ui/core'
import { t } from 'ttag'
import { downloadImage } from '../../../common/helpers/downloadHelpers'
import { ReactComponent as DownloadIcon } from '../../../assets/v3/icons/ranking/download.svg'
import { ReactComponent as CloseIcon } from '../../../assets/v3/icons/close.svg'
import { darkBlue } from '../../../styles/material-ui-theme-v2'

const GalleryActions = () => {
  const [modalEl, setModalEl] = useState<Element | null>(null)

  useEffect(() => {
    const el = document.querySelector('.str-chat__modal--open')
    if (el) setModalEl(el)
  }, [])

  const handleDownload = useCallback((e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    const activeImg = document.querySelector('.image-gallery-slide.image-gallery-center img') as HTMLImageElement
    const url = activeImg?.src
    if (url) {
      downloadImage(url)
    }
  }, [])

  const handleClose = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation()
      // The Stream Chat Modal close button is hidden via CSS but still in the DOM.
      // We need to make it temporarily visible, click it, then hide it again.
      const closeBtn = modalEl?.querySelector('.str-chat__modal__close-button') as HTMLButtonElement
      if (closeBtn) {
        closeBtn.style.display = ''
        closeBtn.click()
        closeBtn.style.display = 'none'
      }
    },
    [modalEl],
  )

  if (!modalEl) return null

  return ReactDOM.createPortal(
    <Box
      sx={{
        position: 'absolute',
        top: '25px',
        right: '25px',
        display: 'flex',
        // @ts-ignore
        gap: '20px',
        alignItems: 'center',
        zIndex: 10,

        /* iOS Safari 11.2, Safari 11 */
        '@supports (bottom: constant(safe-area-inset-bottom))': {
          top: 'calc(constant(safe-area-inset-top) + 25px)',
        },
        /* iOS Safari 11.4+, Safari 11.1+, Chrome 69+, Opera 56+ */
        '@supports (bottom: env(safe-area-inset-bottom))': {
          top: 'calc(env(safe-area-inset-top) + 25px)',
        },
      }}
    >
      <a
        href="#"
        style={{
          width: 24,
          height: 24,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          color: darkBlue,
          lineHeight: 1,
          borderRadius: '50%',
        }}
        download
        onClick={handleDownload}
        title={t`Download image`}
        aria-label={t`Download image`}
      >
        <DownloadIcon aria-hidden="true" />
      </a>
      <button
        type="button"
        onClick={handleClose}
        title={t`Close`}
        aria-label={t`Close`}
        style={{
          width: 24,
          height: 24,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'none',
          border: 0,
          padding: 0,
          color: 'inherit',
          font: 'inherit',
          cursor: 'pointer',
          lineHeight: 1,
          borderRadius: '50%',
        }}
      >
        <CloseIcon aria-hidden="true" />
      </button>
    </Box>,
    modalEl,
  )
}

export const CustomModalGallery: React.FC<ModalGalleryProps> = (props) => {
  return (
    <>
      <GalleryActions />
      <ModalGallery {...props} />
    </>
  )
}
